import React, { useEffect } from 'react';
import { useSecurity } from '../useSecurity';

const SilentCallback: React.FC = () => {
  const { userManager, log } = useSecurity();
  useEffect(() => {
    const hash = window.location.hash;
    log(['silentCallback', hash]);
    userManager.signinSilentCallback().catch((err) => {
      log(['silentCallback', err]);
    });
  }, []);

  return <></>;
};

export default SilentCallback;
